const tr = {
  "srv_general_unknown": "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
  "srv_general_network": "Ağ hatası. Lütfen bağlantınızı kontrol edin.",
  "srv_general_timeout": "İstek zaman aşımına uğradı. Lütfen tekrar deneyin.",
  "srv_general_not_found": "Bulunamadı",
  "srv_general_invalid_id": "Geçersiz id",
  "srv_general_invalid_json": "Geçersiz JSON",
  "srv_auth_admin_only": "Yalnızca yönetici",
  "srv_auth_owner_only": "Yalnızca sahip erişimi",
  "srv_auth_unauthorized": "Yetkisiz",
  "srv_auth_not_authenticated": "Kimlik doğrulanmadı",
  "srv_auth_invalid_token": "Geçersiz token",
  "srv_auth_session_expired": "Yenileme tokenı yok",
  "srv_auth_token_expired": "Token süresi doldu",
  "srv_auth_device_signed_out": "Bu cihazın oturumu kapatıldı",
  "srv_auth_invalid_login": "Geçersiz kullanıcı adı/e-posta veya şifre",
  "srv_auth_wrong_password": "Mevcut şifre yanlış",
  "srv_auth_email_already_exists": "E-posta zaten kayıtlı",
  "srv_auth_email_taken_other": "Bu e-posta artık başka bir hesap tarafından kullanılıyor",
  "srv_auth_same_email": "Bu zaten sizin e-postanız",
  "srv_auth_same_username": "Bu zaten sizin kullanıcı adınız",
  "srv_auth_username_taken": "Kullanıcı adı zaten alınmış",
  "srv_auth_username_invalid": "Kullanıcı adı 3-20 harf, rakam veya alt çizgi içermelidir",
  "srv_auth_user_not_found": "Kullanıcı bulunamadı",
  "srv_auth_password_mismatch": "Şifreler eşleşmiyor",
  "srv_auth_password_weak": "Yeni şifre en az 8 karakter olmalı ve bir harf ile rakam içermelidir",
  "srv_auth_password_same": "Yeni şifre mevcut şifreden farklı olmalıdır",
  "srv_auth_rate_limited": "Çok fazla deneme. Daha sonra tekrar deneyin.",
  "srv_auth_signup_rate_limited": "Bu ağdan çok fazla kayıt yapıldı. Daha sonra deneyin.",
  "srv_auth_verify_link_invalid": "Geçersiz veya daha önce kullanılmış doğrulama bağlantısı",
  "srv_auth_verify_link_expired": "Doğrulama bağlantısının süresi doldu. Lütfen yenisini isteyin.",
  "srv_auth_email_already_verified": "E-posta zaten doğrulandı.",
  "srv_auth_verification_sent": "Doğrulama e-postası gönderildi.",
  "srv_auth_email_change_sent": "Doğrulama bağlantısı yeni e-postaya gönderildi. Değişikliği tamamlamak için onaylayın.",
  "srv_auth_reset_link_invalid": "Geçersiz veya süresi dolmuş sıfırlama bağlantısı",
  "srv_auth_reset_sent": "Hesap varsa sıfırlama bağlantısı gönderildi.",
  "srv_auth_password_updated": "Şifre güncellendi. Lütfen yeni şifrenizle giriş yapın.",
  "srv_auth_password_changed": "Şifre değiştirildi. Lütfen diğer cihazlarınızda tekrar giriş yapın.",
  "srv_auth_signed_out_all": "Tüm cihazlarda oturum kapatıldı",
  "srv_auth_signed_out_others": "Diğer tüm cihazlarda oturum kapatıldı",
  "srv_auth_device_revoked": "Cihazın oturumu kapatıldı",
  "srv_subscription_required": "Bu özellik Premium üyeler içindir",
  "srv_subscription_plan_unavailable": "Test planı mevcut değil.",
  "srv_subscription_order_not_found": "Sipariş bulunamadı",
  "srv_payment_provider_unreachable": "Ödeme sağlayıcısına ulaşılamadı. Tekrar deneyin.",
  "srv_payment_invoice_failed": "Ödeme sağlayıcısı faturayı oluşturamadı. Tekrar deneyin.",
  "srv_payment_not_configured": "Kripto ödeme ağ geçidi henüz yapılandırılmadı. Lütfen NOWPayments API anahtarlarını ekleyin.",
  "srv_payment_invalid_signature": "Geçersiz imza",
  "srv_exchange_connection_not_found": "Bağlantı bulunamadı",
  "srv_exchange_unsupported": "Desteklenmeyen borsa",
  "srv_exchange_unreachable": "Sunucudan borsaya ulaşılamıyor",
  "srv_exchange_key_not_readonly": "Bu API anahtarının işlem/çekim izinleri var. READ-ONLY anahtar oluşturun (Trade ve Withdraw izinlerini kapatın).",
  "srv_exchange_verify_first": "Canlı işlemi etkinleştirmeden önce bağlantıyı doğrulayın",
  "srv_insufficient_balance": "Tutar kullanılabilir bakiyenizi aşıyor",
  "srv_trade_amount_positive": "Tutar 0'dan büyük olmalıdır",
  "srv_trade_invalid_withdrawal": "Geçersiz çekim tutarı",
  "srv_trade_bot_needs_tp_sl": "Bot hem Stop Loss hem Take Profit gerektirir",
  "srv_trade_no_position": "Satılacak açık pozisyon yok",
  "srv_trade_position_not_found": "Pozisyon bulunamadı",
  "srv_trade_symbol_required": "Sembol gerekli",
  "srv_trade_invalid_symbol": "Geçersiz sembol",
  "srv_trade_invalid_interval": "Geçersiz aralık",
  "srv_trade_verify_email": "İşlem açmadan önce lütfen e-postanızı doğrulayın.",
  "srv_trade_verify_email_auto": "Otomatik işlem etkinleştirmeden önce lütfen e-postanızı doğrulayın.",
  "srv_trade_demo_min": "Minimum demo bakiyesi 100",
  "srv_trade_demo_max": "Demo bakiyesi çok yüksek (maks. 10,000,000)",
  "srv_trade_leverage_confirm": "20x üzeri kaldıraç çift onay gerektirir",
  "srv_trade_high_risk_confirm": "15% üzeri risk, Yüksek Risk onayı gerektirir",
  "srv_trade_high_liquidation_risk": "Yüksek tasfiye riski",
  "srv_trade_no_fee": "Ücret yok (7+ gün tutuldu).",
  "srv_insufficient_data": "Bu geriye dönük test için yeterli mum verisi yok",
  "srv_notification_not_found": "Bildirim bulunamadı",
  "srv_nft_image_failed": "Görsel oluşturma başarısız oldu",
  "ntf_cloud_enabled": "Bulut işlemleri etkin — bot 24/7 çalışır.",
  "ntf_cloud_disabled": "Bulut işlemleri devre dışı.",
  "srv_trade_no_price": "{symbol} için fiyat mevcut değil",
  "srv_trade_risk_lock": "Risk kilidi: işlem başına bakiyenin maks. {pct}%",
  "srv_trade_max_leverage": "{symbol} için maksimum kaldıraç {max}x",
  "srv_trade_risk_range": "{symbol} riski 1% ile {max}% arasında olmalıdır",
  "srv_payment_unsupported_currency": "Desteklenmeyen para birimi. Şunlardan birini seçin: {list}",
  "srv_exchange_unsupported_named": "Desteklenmeyen borsa: {name}",
  "srv_auth_username_cooldown": "Kullanıcı adı {days} gün sonra tekrar değiştirilebilir",
  "srv_exchange_connection_error": "Bağlantı hatası: {error}",
  "srv_trade_early_fee": "5% ({fee}) erken çekim ücreti uygulandı.",
  "ntf_risk_drawdown": "Maks. düşüş {dd}%, {limit}% sınırına ulaştı. Tüm pozisyonlar kapatıldı. Bot durduruldu.",
  "ntf_risk_losses": "Arka arkaya {count} kayıp. Bot durduruldu. Devam etmek için onaylayın.",
  "ntf_cooldown": "Arka arkaya {count} kayıp sonrası beklemede — yeni girişler {minutes} dk. duraklatıldı.",
  "ntf_trade_opened": "İşlem açıldı: {symbol} {timeframe} · skor {score} · {leverage}",
  "ntf_nft_opened": "NFT pozisyonu açıldı (Demo): {name}",
  "ntf_nft_closed": "NFT pozisyonu kapatıldı (Demo): P&L {pnl}",
  "ntf_trade_closed": "{reason}: {symbol} kapatıldı · P&L {pnl}",
  "ntf_opportunity": "⚠️ {symbol} · {timeframe} · {action} · Skor {score}. Giriş ${entry} / TP ${tp} / SL ${sl}. Yalnızca bilgilendirme amaçlıdır — yatırım tavsiyesi değildir.",
  "app_name": "FIREBIRD AI",
  "tagline": "Yapay zekâ ile kripto ve NFT alım satımı",
  "login": "Giriş yap",
  "register": "Kayıt ol",
  "logout": "Çıkış yap",
  "email": "E-posta",
  "password": "Şifre",
  "name": "Ad",
  "welcome_back": "Tekrar hoş geldin, trader",
  "create_account": "Hesabını oluştur",
  "no_account": "Hesabın yok mu?",
  "have_account": "Zaten hesabın var mı?",
  "account_created": "Hesap oluşturuldu — $100'lık demo hesabın hazır",
  "loading": "Yükleniyor…",
  "demo_mode": "Demo modu",
  "demo_balance": "Demo bakiye",
  "nav_dashboard": "Kontrol paneli",
  "nav_charts": "Canlı grafikler",
  "nav_signals": "Yapay zekâ sinyalleri",
  "nav_autotrade": "Otomatik alım satım",
  "nav_manual": "Manuel alım satım",
  "nav_scanner": "Memecoin tarayıcı",
  "nav_backtest": "Geri test 5×5",
  "nav_positions": "Pozisyonlar ve raporlar",
  "nav_nft": "NFT koleksiyonu",
  "nav_assistant": "Yapay zekâ asistanı",
  "nav_settings": "Borsa ve ayarlar",
  "nav_subscription": "Premium plan",
  "subscription_subtitle": "Premium alım satım analizlerinin kilidini aç — kriptoyla öde.",
  "current_plan": "Mevcut plan",
  "premium": "Premium",
  "free_plan": "Ücretsiz plan",
  "renews_on": "Yenilenme",
  "active": "Aktif",
  "best_value": "En avantajlı",
  "plan_monthly": "Aylık",
  "plan_annual": "Yıllık",
  "plan_test": "Deneme",
  "days": "g",
  "pay_with_crypto": "Kriptoyla öde",
  "opening_checkout": "Ödeme açılıyor…",
  "gateway_not_ready": "Kripto ödeme ağ geçidi henüz yapılandırılmadı. NOWPayments API anahtarları eklendiğinde Premium ödemesi kullanılabilir olacak.",
  "premium_only": "Yalnızca Premium",
  "premium_gate_desc": "Bu özellik FireBird Premium'a dahildir. Tüm yapay zekâ sinyallerinin, otomatik alım satımın ve fırsat tarayıcının kilidini açmak için Premium'a geç.",
  "go_premium": "Premium'a geç",
  "billing_history": "Ödeme geçmişi",
  "no_invoices": "Henüz fatura yok. Kripto ödemelerin burada görünecek.",
  "date": "Tarih",
  "plan_col": "Plan",
  "amount_col": "Tutar",
  "status_col": "Durum",
  "view_invoice": "Faturayı görüntüle",
  "check_status": "Ödeme durumunu kontrol et",
  "checking": "Kontrol ediliyor…",
  "payment_still_pending": "Ödeme henüz onaylanmadı. Otomatik olarak kontrol edeceğiz.",
  "status_paid": "Ödendi",
  "status_created": "Beklemede",
  "status_partially_paid": "Kısmen ödendi",
  "status_expired": "Süresi doldu",
  "status_failed": "Başarısız",
  "status_refunded": "İade edildi",
  "status_cancelled": "İptal edildi",
  "status_canceled": "İptal edildi",
  "payment_processing": "Ödeme algılandı — Premium planın etkinleştiriliyor…",
  "payment_success": "Premium etkinleştirildi. Hoş geldin!",
  "payment_cancelled": "Ödeme iptal edildi.",
  "payment_error": "Ödeme başlatılamadı. Tekrar dene.",
  "popup_blocked": "Ödeme hazır. Yeni sekme açılmadıysa aşağıdaki bağlantıyı kullan.",
  "checkout_opened_hint": "Ödeme yeni sekmede açıldı. Göremiyor musun?",
  "open_checkout": "Ödemeyi aç",
  "pay_currency_label": "Şuradan öde",
  "pay_currency_hint": "Solana üzerinde USDC ve BSC üzerinde BNB kabul ediyoruz. Seçtiğin varlık ödeme sırasında sabitlenir.",
  "feat_signals": "Tam yapay zekâ sinyalleri (kripto, shitcoin, NFT)",
  "feat_autotrade": "Risk kontrollü otomatik alım satım",
  "feat_scanner": "Memecoin ve fırsat tarayıcı",
  "feat_alerts": "Akıllı e-posta uyarıları",
  "feat_priority": "Öncelikli sinyal teslimi",
  "feat_save": "Aylığa kıyasla 2 ay ücretsiz",
  "feat_test_quick": "Tek seferlik $1 test — gerçek ödeme akışını doğrular",
  "demo_account_settings": "Demo hesap ayarları",
  "demo_settings_desc": "Demo bakiyeni belirle ve alıştırma hesabını sıfırla. Bu yalnızca demo verilerini etkiler — aboneliğin ve gerçek işlemlerin etkilenmez.",
  "custom_demo_balance": "Özel demo bakiye (USDC)",
  "demo_min_hint": "Varsayılan 500 · en az 100",
  "reset_demo_account": "Demo hesabı sıfırla",
  "reset_demo_confirm_title": "Demo hesap sıfırlansın mı?",
  "reset_demo_confirm_desc": "Demo bakiyen ${bal} olarak ayarlanacak, tüm demo işlemler ve K/Z geçmişi silinecek; düşüş, duraklatma ve bekleme durumları sıfırlanacak. Bu işlem geri alınamaz. Aboneliğin ve gerçek verilerin etkilenmez.",
  "demo_reset_done": "Demo hesap sıfırlandı — bakiye ${bal} olarak ayarlandı",
  "demo_min_balance_error": "Minimum demo bakiye 100",
  "nav_guide": "Başlangıç kılavuzu",
  "owner_console": "Sahip konsolu",
  "total_value": "Toplam değer",
  "cash": "Nakit",
  "holdings": "Varlıklar",
  "unrealized_pnl": "Gerçekleşmemiş PnL",
  "top_signals": "En iyi yapay zekâ sinyalleri",
  "market_overview": "Piyasa genel bakışı",
  "whale_activity": "Balinalar ve akıllı para",
  "market_pulse": "Piyasa nabızı",
  "news_up": "{name} 24 saatte %{pct} yükseldi",
  "news_down": "{name} 24 saatte %{pct} düştü",
  "kind_cex": "CEX",
  "kind_iranian_cex": "İran CEX",
  "kind_dex": "DEX",
  "price": "Fiyat",
  "change_24h": "24s",
  "score": "Puan",
  "action": "Eylem",
  "buy": "Al",
  "sell": "Sat",
  "hold": "Tut",
  "timeframe": "Zaman dilimi",
  "symbol": "Sembol",
  "amount_usd": "Tutar (USD)",
  "open_position": "Pozisyon aç",
  "close": "Kapat",
  "no_positions": "Açık pozisyon yok",
  "entry": "Giriş",
  "current": "Güncel",
  "exit": "Çıkış",
  "reason": "Neden",
  "pnl": "PnL",
  "win_rate": "Kazanma oranı",
  "total_trades": "Toplam işlem",
  "total_pnl": "Toplam PnL",
  "wl": "K / Z",
  "open_label": "Açıldı",
  "run_backtest": "Geri testi çalıştır",
  "running": "Çalışıyor…",
  "bt_subtitle": "Strateji her zaman dilimi için 5 geçmiş pencerede test edildi.",
  "window_results": "Pencere sonuçları",
  "window": "Pencere",
  "trades": "İşlemler",
  "return_label": "Getiri",
  "max_drawdown": "Maks. düşüş",
  "auto_trade_on": "Otomatik alım satım aktif",
  "auto_trade_off": "Otomatik alım satım kapalı",
  "enable_autotrade": "Otomatik alım satımı aç (demo)",
  "reset_demo": "Demoyu sıfırla ($100)",
  "activity_log": "Etkinlik günlüğü",
  "waiting_signals": "Sinyaller bekleniyor…",
  "enable_to_start": "Başlamak için otomatik alım satımı aç",
  "reauthorize_bot": "Botu yeniden yetkilendir",
  "leverage": "Kaldıraç",
  "high_leverage_warning": "Yüksek kaldıraç — tüm teminatını kaybedebilirsin (tasfiye).",
  "bot_description": "Bot tüm coinleri 15m / 1h / 4h zaman dilimlerinde tarar, en iyi sinyale girer (2:1 risk-ödül, stop zorunlu) ve demo modunda pozisyonları kayan kar al ile takip eder.",
  "rule_rr": "Kâr:Risk 2:1 (stop zorunlu)",
  "rule_max_concurrent": "Maks. 2 eş zamanlı otomatik işlem",
  "rule_leverage": "Otomatik kaldıraç ≤ 10x · Manuel ≤ 50x",
  "rule_circuit": "%20 düşüşte acil kesici",
  "rule_halt": "5 zarardan sonra duraklat",
  "rule_scan": "Tüm coinleri ve zaman dilimlerini tarar",
  "rule_entry": "Giriş puanı ≥ {score} ({tfs})",
  "rule_cooldown": "{losses} zarardan sonra {min} dk bekleme",
  "risk_status": "Risk durumu",
  "risk_mode_active": "Aktif",
  "risk_mode_halted": "Duraklatıldı",
  "consecutive_losses_label": "Ardışık zarar",
  "drawdown_label": "Düşüş",
  "open_positions_label": "Açık pozisyonlar",
  "max_concurrent_reached": "Maksimum eş zamanlı işlem sayısına ulaşıldı.",
  "bot_reauthorized": "Bot yeniden yetkilendirildi. Otomatik alım satımı tekrar açabilirsin.",
  "cloud_trading": "Bulut alım satımı",
  "enable_cloud": "Bulut alım satımını aç",
  "disable_cloud": "Bulut alım satımını kapat",
  "cloud_status": "Bulut durumu",
  "cloud_on": "7/24 çalışıyor",
  "cloud_off": "Kapalı",
  "cloud_desc": "Bot, cihazın kapalı olsa bile sunucularımızda 7/24 çalışır.",
  "notifications": "Bildirimler",
  "no_notifications": "Henüz bildirim yok",
  "mark_all_read": "Tümünü okundu işaretle",
  "connect_exchange": "Borsa bağla",
  "api_key": "API anahtarı",
  "api_secret": "API gizli anahtarı",
  "api_key_optional": "API anahtarı (açık fiyatlar için isteğe bağlı)",
  "connect": "Bağla",
  "test": "Test et",
  "remove": "Kaldır",
  "verified": "Doğrulandı",
  "not_verified": "Doğrulanmadı",
  "connected_exchanges": "Bağlı borsalar",
  "aggregated_balances": "Bakiyeler · Tüm borsalar",
  "aggregated_prices": "Canlı fiyatlar · Tüm borsalar",
  "no_connections": "Henüz bağlı borsa yok.",
  "connect_wallet": "Cüzdan bağla",
  "wallet_connected": "Cüzdan bağlandı",
  "wallet_note": "Emanet gerektirmez — özel anahtarlarını asla saklamayız.",
  "wallet_security": "Cüzdan ve güvenlik",
  "wallet_never_ask": "Özel anahtarını veya kurtarma cümleni asla istemeyiz.",
  "disconnect_wallet": "Cüzdanı ayır",
  "switch_chain": "Ağı değiştir",
  "native_balance": "Yerel token bakiyesi",
  "wallet_chain": "Ağ",
  "dex_onchain": "DEX (zincir üzeri)",
  "sign_in_wallet": "Cüzdanla giriş yap",
  "waiting_signature": "Cüzdan imzası bekleniyor…",
  "dex_demo_note": "Cüzdanınla imzalıyorsun — anahtarlar cihazından asla çıkmaz.",
  "view_on_explorer": "Gezginde görüntüle",
  "wallet_required_dex": "Zincir üzerinde işlem yapmak için bir cüzdan bağla.",
  "tx_pending": "İşlem beklemede…",
  "tx_confirmed": "İşlem onaylandı",
  "tx_failed": "İşlem başarısız",
  "connected_label": "Bağlı",
  "not_connected_label": "Bağlı değil",
  "copy_address": "Adresi kopyala",
  "readonly_warning": "YALNIZCA OKUMA yetkili bir API anahtarı oluştur. Çekim ve işlem iznini kapat.",
  "cex_security_notice": "Özel anahtarlarını ASLA saklamayız ve çekim izni istemeyiz.",
  "api_passphrase_optional": "Parola cümlesi (isteğe bağlı)",
  "read_only_label": "Salt okunur",
  "how_to_create_key": "Salt okunur anahtar nasıl oluşturulur",
  "connected_wallets": "Bağlı cüzdanlar",
  "no_wallet_connected": "Bağlı cüzdan yok.",
  "no_exchange_linked": "Bağlı borsa yok.",
  "smart_contract_allowances": "Akıllı sözleşme izinleri",
  "no_allowances": "Aktif izin yok.",
  "revoke": "İptal et",
  "max_spend": "Maks. harcama",
  "link_readonly_hint": "Salt okunur bir anahtar eklemek için \"Borsa bağla\" panelini kullan.",
  "vpn_notice": "Bazı bölgelerdeki kullanıcılar için bu pazar yeri VPN gerektirebilir.",
  "ir_friendly": "İran'a uygun",
  "best_price": "En iyi fiyat",
  "marketplace_listings": "Pazar yeri ilanları",
  "tab_opps": "Fırsatlar",
  "opportunities": "Fırsatlar",
  "high_opportunity": "Yüksek fırsat",
  "alerts_triggered_today": "bugün uyarı",
  "score_range": "Puan aralığı",
  "timeframe_label": "Zaman dilimi",
  "direction_label": "Yön",
  "risk_disclaimer_title": "Risk uyarısı",
  "risk_disclaimer": "Sinyaller yalnızca bilgilendirme amaçlıdır. Bu yatırım tavsiyesi DEĞİLDİR. Shitcoinlerin %98'i başarısız olur. Her zaman zarar durdur kullan. İşlem başına asla %1–5'ten fazla risk alma.",
  "no_opportunities": "Şu anda fırsat yok. Tarayıcı her 5 dakikada bir çalışır.",
  "alerts_title": "Uyarılar",
  "enable_scanner": "Otomatik tarayıcıyı aç",
  "min_score_label": "Minimum puan",
  "monitor_timeframes": "İzlenecek zaman dilimleri",
  "max_alerts_day": "Günlük maks. uyarı",
  "notify_method_label": "Bildirim yöntemi",
  "notify_in_app": "Yalnızca uygulama içi",
  "notify_in_app_email": "Uygulama içi + e-posta",
  "alert_history_title": "Uyarı geçmişi",
  "no_alert_history": "Henüz uyarı yok.",
  "nft_markets": "NFT pazar yerleri",
  "iran_friendly": "İran'a uygun",
  "key_security_note": "Anahtarlar sunucuda şifrelenir ve tarayıcında asla saklanmaz.",
  "exchange": "Borsa",
  "no_balances": "Bakiye yok (canlı bakiyeleri yüklemek için API anahtarları ekle).",
  "safety": "Güvenlik",
  "opportunity": "Fırsat",
  "holders": "Sahipler",
  "verdict": "Karar",
  "coin": "Kripto para",
  "chain": "Ağ",
  "scanning": "Taranıyor…",
  "scanner_subtitle": "Alım satım yapılabilir likiditeye sahip seçilmiş memecoinler (puan ≥ 75). Bilinmeyen ve dolandırıcı tokenlar gösterilmez.",
  "safety_note": "Güvenlik = kilitli likidite + vazgeçilmiş mint + sahip dağılımı (tahmini, yatırım tavsiyesi değildir).",
  "ask_ai": "Firebird AI'a sor...",
  "send": "Gönder",
  "chat": "Sohbet",
  "ai_empty": "Bir coin, zaman dilimi veya strateji hakkında sor. Buradaki hiçbir şey yatırım tavsiyesi değildir.",
  "ai_thinking": "Firebird AI düşünüyor…",
  "ai_error": "Üzgünüm, şu anda yanıt veremedim.",
  "score_coin": "Bu coini puanla",
  "any_coin_symbol": "Herhangi bir coin sembolü",
  "analyzing": "Analiz ediliyor…",
  "entry_strategy": "Giriş",
  "exit_strategy": "Çıkış",
  "risk": "Risk",
  "signals_subtitle": "Tüm coinlerde yapay zekâ + teknik puan",
  "momentum": "Momentum",
  "simulated_feed": "simüle edilmiş akış",
  "collection": "Firebird 555 Koleksiyonu",
  "nft_subtitle": "Firebird / Anka — 555 öğe · 6 efsanevi nadirlik · her birinin kendi yıkım ve yeniden doğuş hikayesi var",
  "rares": "Efsanevi nadirlikler",
  "floor_price": "Taban fiyat",
  "minted": "Bastırılan",
  "total_supply": "Toplam arz",
  "rarity": "Nadirlik",
  "bt_download": "İndir",
  "bt_stop_loss": "Zarar durdur (TP = 2× SL)",
  "bt_min_score": "Min. sinyal skoru",
  "bt_share": "Paylaş",
  "bt_history": "Kaydedilen geriye dönük testler",
  "bt_card_saved": "Sonuç kartı indirildi",
  "bt_compare_tf": "Zaman dilimlerini karşılaştır",
  "bt_best": "EN İYİ",
  "bt_worst": "EN KÖTÜ",
  "bt_run_all": "Tüm coinleri çalıştır",
  "bt_by_section": "Bölümlere göre sonuçlar",
  "bt_per_coin": "Coin başına sonuçlar",
  "bt_avg_return": "Ort. getiri",
  "bt_skipped": "Atlandı (yeterli veri yok)",
  "bt_sec_major": "Ana",
  "bt_sec_shitcoin": "Değersiz coin",
  "bt_sec_meme": "Meme",
  "bt_sec_nft": "NFT tokenları",
  "bt_sec_other": "Diğer",
  "bt_data_live": "CANLI piyasa verisi",
  "bt_data_simulated": "SİMÜLE EDİLMİŞ veri (canlı piyasa verisi yok)",
  "risk_per_trade": "İşlem başına risk",
  "max_amount": "Maks.",
  "tier_major": "Büyük ölçekli",
  "tier_mid": "Orta ölçekli",
  "tier_meme": "Meme/Pump",
  "high_risk_ack": "Bunun YÜKSEK RİSKLİ bir işlem olduğunu anlıyorum (bakiyemin %15'inden fazlası).",
  "lev_warn_yellow": "Yüksek tasfiye riski",
  "lev_warn_red": "Aşırı kaldıraç — çok yüksek tasfiye riski. Çift onay gerekir.",
  "lev_ack": "Tüm teminatımı kaybedebileceğimi anlıyorum.",
  "lev_confirm_again": "Aşırı kaldıraç: onaylamak için tekrar tıkla.",
  "confirm_again": "Tekrar onayla",
  "high_risk_required": "Lütfen yüksek risk onayını işaretle.",
  "lev_ack_required": "Lütfen aşırı kaldıraç uyarısını onayla.",
  "trait_element": "Öğe",
  "trait_aura": "Aura",
  "trait_background": "Arka plan",
  "prev": "Geri",
  "next": "İleri",
  "all": "Tümü",
  "save": "Kaydet",
  "risk_lock": "Risk koruması",
  "max_position": "Maks. pozisyon %",
  "trailing_stop": "İzleyen stop %",
  "take_profit": "Kâr al %",
  "stop_loss": "Zarar durdur %",
  "risk_strategy": "Risk ve strateji",
  "exchanges": "Borsa bağlantıları",
  "connected": "Bağlı",
  "disconnected": "Bağlı değil",
  "withdraw_demo_wallet": "Çekim (demo cüzdan)",
  "withdraw_fee_note": "Son yatırmadan sonra 7 günden önce yapılan çekimlerde %5 erken çekim ücreti alınır (sahip payı).",
  "withdraw": "Çek",
  "trade_history": "İşlem geçmişi",
  "no_closed_trades": "Henüz kapalı işlem yok",
  "owner_subtitle": "Tüm kullanıcıların performansı (salt okunur) · ücret defteri (her kârlı işlemden %2, haftalık mutabakat · erken çekimde %5)",
  "total_users": "Toplam kullanıcı",
  "total_commission": "Toplam ücret",
  "this_week": "Bu hafta",
  "total_volume": "Toplam hacim",
  "all_time": "tüm zamanlar",
  "settles_weekly": "haftalık mutabakat",
  "commission_breakdown": "Ücret dökümü",
  "from_trade_profits": "İşlem kârından (%2)",
  "from_withdrawal_fees": "Erken çekim ücretlerinden (%5)",
  "owner_rate": "Sahip oranı",
  "settlement": "Mutabakat",
  "early_exit_fee": "Erken çıkış ücreti",
  "weekly": "Haftalık",
  "daily_accrual": "Günlük birikim",
  "no_commission_yet": "Henüz ücret yok — kârlı işlemlerden birikir.",
  "users_performance": "Kullanıcı performansı (salt okunur)",
  "col_user": "Kullanıcı",
  "col_role": "Rol",
  "col_joined": "Kayıt tarihi",
  "col_volume": "Hacim",
  "col_balance": "Bakiye",
  "role_owner": "sahip",
  "role_user": "kullanıcı",
  "guide_intro": "Firebird AI Trade'e hoş geldin. Güvenle başlamak için bu adımları izle.",
  "guide_step": "Adım",
  "guide1_title": "Demo modu açık",
  "guide1_desc": "$100 demo bakiyeyle başlıyorsun. Kendi güvenli anahtarlarınla gerçek işlemi açıkça etkinleştirmedikçe gerçek para kullanılmaz.",
  "guide2_title": "Kontrol panelini incele",
  "guide2_desc": "Portföy değeri, en iyi yapay zekâ sinyalleri, piyasa genel bakışı, balina hareketleri ve piyasa nabızı — hepsi tek yerde.",
  "guide3_title": "Yapay zekâ sinyallerine göz atın",
  "guide3_desc": "Coinler RSI, SMA kesişimleri ve çoklu zaman dilimi momentumuna göre 0–100 arası puanlanır.",
  "guide4_title": "Yapay zekâ asistanına sor",
  "guide4_desc": "Firebird AI Core'dan (GPT-5.6) giriş/çıkış stratejisi ve risk notlarıyla bir coin puanı al.",
  "guide5_title": "Otomatik alım satımı dene (demo)",
  "guide5_desc": "Botun güçlü sinyallerde alım pozisyonları açmasına ve bunları izleyen stop / kâr al ile takip etmesine izin ver.",
  "guide6_title": "Memecoinleri tara",
  "guide6_desc": "Yalnızca yüksek güvenlik puanlı, alım satım yapılabilir memecoinler gösterilir — bilinmeyen veya dolandırıcı token yok.",
  "guide7_title": "Firebird 555 NFT'lerini keşfet",
  "guide7_desc": "6 efsanevi nadirliğe sahip 555 ankadan oluşan koleksiyona göz at.",
  "disclaimer": "Demo/deneme alanı. Buradaki hiçbir şey yatırım tavsiyesi değildir. Hiçbir sistem gelecekteki kazanma oranını garanti edemez.",
  "src_manual": "Manuel",
  "src_auto": "Otomatik",
  "tier_legendary": "Efsanevi",
  "tier_epic": "Destansı",
  "tier_rare": "Nadir",
  "tier_common": "Sıradan",
  "verdict_tradeable": "Alım satıma uygun",
  "verdict_watch": "İzle",
  "pressure_accumulation": "Birikim",
  "pressure_distribution": "Dağıtım",
  "reason_take_profit": "Kâr al",
  "reason_liquidation": "Tasfiye",
  "reason_stop_loss": "Zarar durdur",
  "reason_trailing_take_profit": "Kayan kâr al",
  "reason_trailing_stop": "İzleyen stop",
  "reason_signal_flip": "Sinyal dönüşü",
  "welcome": "Hoş geldin",
  "trader": "yatırımcı",
  "live": "Canlı",
  "verify_email_banner": "İşlem açmak için e-postanı doğrula. Doğrulama bağlantısını gelen kutunda ara.",
  "resend": "Tekrar gönder",
  "verification_sent": "Doğrulama e-postası gönderildi",
  "could_not_resend": "Tekrar gönderilemedi",
  "search_coin_placeholder": "Herhangi bir coin ara (ör. BTC, PEPE, ARB)",
  "add_to_watchlist": "İzleme listesine ekle",
  "free_balance": "Serbest bakiye",
  "in_positions": "Pozisyonlarda",
  "total_equity": "Toplam özkaynak",
  "watchlist": "İzleme listesi",
  "watchlist_empty": "Henüz coin yok — arayıp eklemek için + simgesine dokun.",
  "high_exposure": "Serbest bakiyenin %{percent}'i kullanılıyor — yüksek risk maruziyeti.",
  "advanced_tpsl": "Gelişmiş TP / SL",
  "entry_optional": "Giriş (isteğe bağlı — varsayılan piyasa)",
  "market": "piyasa",
  "take_profit_price": "Kâr al fiyatı",
  "stop_loss_price": "Zarar durdur fiyatı",
  "tp_example": "ör. 72000",
  "sl_example": "ör. 66000",
  "if_tp_hits": "TP tetiklenirse",
  "if_sl_hits": "SL tetiklenirse",
  "pnl_preview_note": "${amount} teminat × {leverage}x üzerinden. Çizgiler grafiğe çizildi →",
  "clear_tpsl": "TP/SL'yi temizle",
  "one_tap_trade": "Tek dokunuşla işlem",
  "tp_short": "TP",
  "sl_short": "SL",
  "auto_signals": "Otomatik sinyaller",
  "add_token_placeholder": "Herhangi bir token ekle (ör. ARB, OP, TIA)",
  "analyze": "Analiz et",
  "analyzing_on": "{symbol} {tf} analiz ediliyor…",
  "tap_to_load": "Grafiğe yüklemek için dokun →",
  "scanning_market": "Piyasa taranıyor…",
  "no_signals": "Henüz sinyal yok.",
  "money_depth": "Piyasa para derinliği",
  "sr_zones": "Destek/direnç bölgeleri",
  "bot_analysis": "Bot analizi",
  "confidence": "Güven",
  "reasoning": "Gerekçe",
  "tp_label": "Kâr al",
  "sl_label": "Zarar durdur",
  "risk_reward": "Risk : Ödül",
  "levels_from_position": "Açık pozisyonunun canlı seviyeleri",
  "levels_suggested": "Önerilen seviyeler · yatırım tavsiyesi değildir",
  "toast_opened": "{symbol} {leverage}x pozisyonu açıldı",
  "toast_closed": "{symbol} kapatıldı · PnL ${pnl}",
  "toast_closed_pnl": "Kapatıldı · PnL ${pnl}",
  "ago_s": "{n} sn önce",
  "ago_m": "{n} dk önce",
  "ago_h": "{n} sa önce",
  "ago_d": "{n} g önce",
  "in_label": "Giriş akışı",
  "out_label": "Çıkış akışı",
  "confirm_reveal_email": "Bu kullanıcının e-postası gösterilsin mi? E-posta gizlidir — yalnızca gerekirse bak.",
  "view_email_private": "E-postayı göster (gizli)",
  "display_name_updated": "Görünen ad güncellendi",
  "change_email_sent": "Doğrulama bağlantısı yeni e-postaya gönderildi",
  "username_updated": "Kullanıcı adı güncellendi",
  "password_changed": "Şifre değiştirildi. Diğer cihazlarda tekrar giriş yap.",
  "confirm_logout_all": "Tüm cihazlardan çıkış yapılsın mı? Tekrar giriş yapman gerekecek.",
  "no_wallet": "Cüzdan eklentisi algılanamadı (MetaMask/WalletConnect).",
  "wallet_rejected": "Cüzdan bağlantısı reddedildi.",
  "profile_security": "Profil ve güvenlik",
  "display_name": "Görünen ad",
  "display_name_optional": "Görünen ad (isteğe bağlı)",
  "edit": "Düzenle",
  "cancel": "İptal",
  "change": "Değiştir",
  "in_days": "{days} gün sonra",
  "username_label": "Kullanıcı adı",
  "username_hint": "3–20 harf, rakam veya alt çizgi. 30 günde bir değiştirilebilir.",
  "username_example": "ör. arash_king",
  "email_private": "E-posta (gizli)",
  "change_email": "E-postayı değiştir",
  "unverified": "Doğrulanmadı",
  "resend_verification": "Doğrulamayı tekrar gönder",
  "new_email": "Yeni e-posta",
  "current_password": "Mevcut şifre",
  "new_password": "Yeni şifre",
  "confirm_new_password": "Yeni şifreyi doğrula",
  "send_verification_new": "Yeni e-postaya doğrulama gönder",
  "change_email_hint": "Değişikliği yeni e-postana gönderilen bağlantıyla onaylayacak ve ardından tekrar giriş yapacaksın.",
  "email_private_hint": "E-postan asla herkese açık gösterilmez. Burada yalnızca sen görürsün.",
  "sessions": "Oturumlar",
  "logout_all_devices": "Tüm cihazlardan çıkış yap",
  "change_password": "Şifreyi değiştir",
  "pw_hint": "En az 8 karakter, bir harf ve bir rakam.",
  "update_password": "Şifreyi güncelle",
  "coin_example_placeholder": "ör. BTC, PEPE, TAO...",
  "username_or_email": "Kullanıcı adı veya e-posta",
  "forgot_password_q": "Şifreni mi unuttun?",
  "invalid_email": "Geçerli bir e-posta adresi gir",
  "pw_mismatch": "Şifreler eşleşmiyor",
  "username_hint_short": "3–20 harf, rakam veya alt çizgi",
  "account_created_verify": "Hesap oluşturuldu! Hesabını doğrulamak için e-postanı kontrol et.",
  "confirm_password_label": "Şifreyi doğrula",
  "missing_verify_token": "Doğrulama jetonu eksik.",
  "email_verified_msg": "E-posta doğrulandı!",
  "verification_failed": "Doğrulama yapılamadı.",
  "verifying_email": "E-postan doğrulanıyor…",
  "email_verified_title": "E-posta doğrulandı",
  "go_to_login": "Girişe git",
  "verification_failed_title": "Doğrulama başarısız",
  "verify_expired_hint": "Bağlantının süresi mi doldu? Giriş yap ve ayarlardan \"Doğrulamayı tekrar gönder\" seçeneğini kullan.",
  "back_to_login": "← Girişe dön",
  "forgot_password": "Şifremi unuttum",
  "forgot_subtitle": "Kullanıcı adını veya e-postanı gir, sıfırlama bağlantısı gönderelim.",
  "forgot_sent_toast": "Hesap varsa bir sıfırlama bağlantısı gönderildi.",
  "forgot_sent_full": "Hesap varsa bir sıfırlama bağlantısı gönderildi. E-postanı kontrol et (15 dakika geçerli).",
  "send_reset_link": "Sıfırlama bağlantısı gönder",
  "remembered_it": "Hatırladın mı?",
  "missing_reset_token": "Sıfırlama jetonu eksik. E-postandaki bağlantıyı kullan.",
  "pw_requirement": "Şifre en az 8 karakter olmalı ve bir harf ile bir rakam içermeli",
  "password_updated": "Şifre güncellendi.",
  "reset_password": "Şifreyi sıfırla",
  "reset_subtitle": "Hesabın için yeni bir şifre seç.",
  "reset_invalid": "Sıfırlama bağlantısı geçersiz veya eksik. Yeni bir tane iste.",
  "request_reset_link": "Sıfırlama bağlantısı iste",
  "new_password_label": "Yeni şifre",
  "pw_hint2": "En az 8 karakter, bir harf ve bir rakam içermeli.",
  "update_password_btn": "Şifreyi güncelle",
  "bullish": "Boğa",
  "bearish": "Ayı",
  "inflow": "giriş",
  "outflow": "çıkış",
  "volume_up": "Hacim artıyor",
  "volume_down": "Hacim düşüyor",
  "money_flow_mfi": "Para akışı (MFI 14)",
  "flow_overbought": "Aşırı alım",
  "flow_oversold": "Aşırı satım",
  "flow_bullish": "Boğa girişi",
  "flow_bearish": "Ayı çıkışı",
  "support": "Destek",
  "resistance": "Direnç",
  "available_for_trade": "Alım satıma uygun",
  "free_balance_after": "Sonrasında serbest bakiye",
  "tab_major": "Büyük ölçekli",
  "tab_shitcoins": "Shitcoinler",
  "tab_nfts": "NFT",
  "filter_direction": "Yön",
  "buy_only": "Yalnızca al",
  "sell_only": "Yalnızca sat",
  "min_confidence": "Min. güven",
  "confirm": "Onayla",
  "safety_score": "Güvenlik puanı",
  "liquidity_lock": "Likidite kilidi",
  "locked": "Kilitli",
  "unlocked": "Kilitsiz",
  "honeypot": "Tuzak",
  "honeypot_safe_label": "Güvenli",
  "honeypot_risk": "Risk",
  "nft_demo_notice": "Demo işlem — gerçek NFT satın alınmaz",
  "view_on_opensea": "OpenSea'de aç",
  "volume_24h": "Hacim (24s)",
  "nft_position_opened": "NFT pozisyonu açıldı (demo)",
  "crypto_positions_title": "Kripto ve shitcoin pozisyonları",
  "nft_positions_title": "NFT pozisyonları",
  "min_safety_required": "İşlem için güvenlik puanı ≥ 75 olmalı",
  "amount_exceeds_balance": "Tutar serbest bakiyeni aşıyor",
  "amount_gt_zero": "Tutar 0'dan büyük olmalı",
  "confirm_trade": "İşlemi onayla",
  "usd_equiv": "≈",
  "nft_badge": "NFT",
  "no_nft_positions": "Açık NFT pozisyonu yok",
  "floor": "Taban",
  "rr_short": "K:Z",
  "best_marketplace": "En iyi pazar",
  "story": "Geçmiş",
  "show_more": "Daha fazla göster",
  "show_less": "Daha az göster",
  "view_chart": "Grafiği görüntüle",
  "reason_sma_bull": "SMA9, SMA21'in üzerinde (yükseliş eğilimi)",
  "reason_sma_bear": "SMA9, SMA21'in altında (düşüş eğilimi)",
  "reason_rsi_oversold": "aşırı satım",
  "reason_rsi_overbought": "aşırı alım",
  "reason_rsi_neutral": "nötr",
  "reason_pos_momentum": "Pozitif momentum",
  "reason_neg_momentum": "Negatif momentum",
  "reason_insufficient": "Yetersiz veri",
  "reason_whale_accum": "Balina birikimi",
  "reason_rising_floor": "Yükselen taban",
  "reason_falling_floor": "Düşen taban",
  "reason_high_rarity": "Yüksek nadirlik",
  "reason_mid_rarity": "Orta nadirlik",
  "nft_trade_history": "NFT işlem geçmişi",
  "no_nft_trades": "Henüz kapalı NFT işlemi yok",
  "entry_floor": "Girişte taban",
  "exit_floor": "Çıkışta taban",
  "verify_reminder": "E-postan henüz doğrulanmadı — işlem açmak için doğrula.",
  "verify_now": "Şimdi doğrula",
  "dismiss": "Kapat",
  "trusted_devices": "Aktif oturumlar · Hesabına giriş yapmış cihazlar",
  "font_size": "Yazı boyutu",
  "font_small": "Küçük",
  "font_medium": "Orta",
  "font_large": "Büyük",
  "sessions_hint": "Hesabına giriş yapmış telefonlar ve tarayıcılar (borsa API anahtarları değil).",
  "unknown_device": "Bilinmeyen cihaz",
  "this_device": "Bu cihaz",
  "current_session": "Mevcut",
  "last_active": "Son etkinlik",
  "revoke_all_others": "Diğer tüm cihazlardan çıkış yap",
  "revoke_all_others_done": "Diğer tüm cihazlardan çıkış yapıldı",
  "no_other_devices": "Başka aktif cihaz yok",
  "device_revoked": "Cihaz hesaptan kaldırıldı",
  "ui_logo_alt": "Firebird / Simorgh Trade logosu",
  "ui_logo_switch_hint": "Logoyu değiştirmek için dokunun",
  "ui_vpn_info": "VPN bilgileri"
};
export default tr;
